import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "eudate",
  pure: true,
})
export class EudatePipe implements PipeTransform {
  public transform(date: string) {
    return date.replace(/(\d+)-(\d+)-(\d+)/, "$3-$2-$1");
  }
}



// WEBPACK FOOTER //
// ./src/pipes/eudate/eudate.ts